import { useState, useCallback } from "react";

import httpclient from "../../../../../../Utils";
import { transformDayDetails } from "../utils/transformers";

export const useDayDetails = () => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDayDetails = useCallback(async (driverId, dateStr) => {
    try {
      setLoading(true);
      setError(null);
      const response = await httpclient.get(
        `/delivery/reports/drivers/delivery-report-day-details/${driverId}?date=${dateStr}`
      );

      if (response.data && response.data.status === 200) {
        const transformedDayData = transformDayDetails(response.data.data);
        setSelectedDay(transformedDayData);
        return transformedDayData;
      }
    } catch (err) {
      console.error("Error fetching day details:", err);
      setError("Failed to load day details. Please try again.");
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearSelectedDay = useCallback(() => {
    setSelectedDay(null);
    setError(null);
  }, []);

  return {
    selectedDay,
    loading,
    error,
    fetchDayDetails,
    clearSelectedDay,
  };
};
